import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteItineraryGroup } from '../../../../actions';

class ItineraryGroupDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteItineraryGroup, itineraryGroupId } = this.props;
    dispatchDeleteItineraryGroup({ itineraryGroupId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

ItineraryGroupDeleteButton.propTypes = {
  itineraryGroupId: PropTypes.number.isRequired,
  dispatchDeleteItineraryGroup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteItineraryGroup: deleteItineraryGroup,
};

export default connect(null, mapDispatchToProps)(ItineraryGroupDeleteButton);
